
import { Step } from "@/types";
import { defineComponent, reactive, ref, computed, toRefs } from "vue";
export default defineComponent({
  name: "GammaStepper",

  props: {
    steps: {
      type: Array as () => Step[],
      required: true,
    },
  },

  setup(props) {
    const states = reactive({
      currentIndex: ref(0),
    });
    const activeStep = computed(() => props.steps[states.currentIndex]);
    const canGoNext = computed(() =>
      activeStep.value.canGoNext != null
        ? activeStep.value.canGoNext().value
        : true
    );
    function goToNextPage() {
      states.currentIndex += 1;
    }
    function goToPreviousPage() {
      states.currentIndex -= 1;
    }
    return {
      activeStep,
      canGoNext,
      ...toRefs(states),
      goToNextPage,
      goToPreviousPage,
    };
  },
});
